<template>
  <div>
    <div style="display:block; position:absolute;top:-9999px">
      <div class="previewContainer2"
           style="border:none"
           ref="outputImg"
           :class="{
             'backgroundDiplome':printWithBackground && backgroundStyle==='coach',
           }"
      >
        <img
          class="photo"
          v-if="photo_base64"
          width="385"
          height="500"
          :src="photo_base64"/>

        <div class="caption">
          <div class="captionContainer">

            <div class="hrVertical"
                 :class="{
                           'backgroundDiplome':backgroundStyle==='coach',
                          }"
            ></div>
          </div>
        </div>

      </div>
    </div>

    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1>
          Génération de diplômes (grade, arbitrage, ...)
          <small></small>
        </h1>
        <ol class="breadcrumb">
          <li>
            <router-link :to="{ name: 'Dashboard'}">
              <i class="fa fa-dashboard"></i>
              Accueil
            </router-link>
          </li>
          <li><a href="#">Outils</a></li>
          <li class="active">Génération diplome pré-imprimée</li>
        </ol>
      </section>

      <section class="content">
        <div class="row">
          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">

            <div class="box box-primary">
              <div class="overlay"
                   v-if="generatingDiplome">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div class="box-header with-border">
                <h3 class="box-title">Aide à la génération</h3>
              </div>

              <div class="box-body">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="form-group">
                      <label>Recherche de membre</label>
                      <v-select v-model="memberSelected"
                                id="searchmember"
                                label="fullName"
                                :filterable="false"
                                :taggable="false"
                                :debounce="250"
                                :on-search="SearchMembersResponse"
                                :options="ArrayMembersSearch">
                                            <span slot="selected-option" slot-scope="props">
                                                <router-link
                                                  :to="{ name: 'Member', params: { member_id: props.selectedOption.id }}">
                                                {{ props.selectedOption.fullName }}  - {{
                                                    props.selectedOption.club.club
                                                  }}
                                                </router-link>
                                            </span>
                        <template slot="option" slot-scope="props">
                                        <span :class="props.item.licencie ? 'text-green' : 'text-red'">
                                            {{ props.item.fullName }} - {{ props.item.club.club }}
                                        </span>
                        </template>
                      </v-select>
                    </div>
                    <hr>
                  </div>
                </div>
              </div>
            </div>


            <div class="box box-primary">
              <div class="overlay"
                   v-if="generatingDiplome">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div class="box-header with-border">
                <h3 class="box-title">Informations</h3>
              </div>

              <div class="box-body">
                <div class="row">
                  <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label for="legend_block_left">Légende du bloc gauche</label>
                      <input type="text" class="form-control" id="legend_block_left"
                             placeholder="" v-model="legend_block_left">
                    </div>
                    <div class="form-group">
                      <label for="text_block_left">Texte du bloc gauche</label>
                      <input type="text" class="form-control" id="text_block_left"
                             placeholder="" v-model="text_block_left">
                    </div>

                  </div>
                  <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    <div class="form-group">
                      <label for="legend_block_right">Légende du bloc droit</label>
                      <input type="text" class="form-control" id="legend_block_right"
                             placeholder="" v-model="legend_block_right">
                    </div>
                    <div class="form-group">
                      <label for="text_block_right">Texte du bloc droit</label>
                      <input type="text" class="form-control" id="text_block_right"
                             placeholder="" v-model="text_block_right">
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
            <div class="box box-primary">
              <div class="overlay"
                   v-if="generatingDiplome">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div class="box-header with-border">
                <h3 class="box-title">Aperçu</h3>
              </div>

              <div class="box-body boxSize">
                <div class="previewZoomOut">
                  <div :class="{
                    'previewContainer':true,
                     'backgroundDiplome':printWithBackground && backgroundStyle==='diplome',
                   }"
                  >

                    <div class="block_left">
                      <div class="legend editable_input"
                           @click="inputActive='input_legend_block_left'"
                           v-click-outside="clickOutside">
                        <span v-show='inputActive!="input_legend_block_left"'>
                          {{ legend_block_left }}
                        </span>
                        <input type="text"
                               v-show='inputActive=="input_legend_block_left"'
                               class="form-control"
                               id="input_legend_block_left"
                               placeholder=""
                               v-model="legend_block_left">
                      </div>
                      <div class="text editable_input"
                           @click="inputActive='input_text_block_left'"
                           v-click-outside="clickOutside"
                      >
                         <span v-show='inputActive!="input_text_block_left"'>
                          {{ text_block_left }}
                        </span>
                        <input type="text"
                               v-show='inputActive=="input_text_block_left"'
                               class="form-control"
                               id="input_text_block_left"
                               placeholder=""
                               v-model="text_block_left">
                      </div>
                    </div>
                    <div class="block_right">
                      <div class="legend">
                        <span>{{ legend_block_right }}</span>
                      </div>
                      <div class="text">
                        <span>{{ text_block_right }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-footer">
                <div class="col-md-4">
                  <div class=" pull-left">
                    <div class="form-group">
                      <label>Type de diplome:</label>
                      <div class="radio">
                        <label>
                          <input type="radio" v-model="backgroundStyle" name="backgroundStyle"
                                 id="optionsRadios1" value="coach" checked="">
                          Diplome de grade
                        </label>
                      </div>
                      <div class="radio">
                        <label>
                          <input type="radio" v-model="backgroundStyle" name="backgroundStyle"
                                 id="optionsRadios2" value="arb_cbt">
                          Diplome d'arbitrage combat
                        </label>
                      </div>
                      <div class="radio">
                        <label>
                          <input type="radio" v-model="backgroundStyle" name="backgroundStyle"
                                 id="optionsRadios3" value="arb_tch">
                          Diplome d'arbitrage technique
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <div class="checkbox">
                      <label>
                        <input type="checkbox" v-model="provisoire" value="">
                        Diplome provisoire
                      </label>
                    </div>
                  </div>

                  <div class="form-group"
                       :class="{'has-error': errors.has('date_fin_provisoire') }"
                       v-if="provisoire">
                    <label>Date de fin</label>
                    <div class="input-group date">
                      <div class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                      </div>
                      <masked-input type="text"
                                    v-model="date_fin_provisoire"
                                    v-validate="'date_format:DD/MM/YYYY'"
                                    :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                    :guide="true"
                                    :keepCharPositions="true"
                                    :showMask="true"
                                    name="date_fin_provisoire"
                                    class="form-control pull-right datepicker"
                                    id="datepicker2"
                      >
                      </masked-input>
                    </div>
                    <span v-show="errors.has('date_fin_provisoire')"
                          class="help-block">Date incorrecte</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="pull-right">
                    <div class="checkbox">
                      <label>
                        <input type="checkbox" v-model="printWithBackground" value="">
                        Imprimer avec le fond
                      </label>
                    </div>
                    <button
                      @click="generateDiplome()"
                      :disabled="generatingDiplome"
                      type="button" class="btn btn-primary pull-right" style="margin-right: 5px;">
                      <i class="fa fa-download"></i> Télécharger la diplome
                    </button>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </section>
      <!-- OUTPUT -->
      <img :src="output">
    </div>

  </div>
</template>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

.previewContainer {
  width: 1052px;
  height: 744px;
  display: block;
  margin: auto;
  border: 1px solid #000;
  position: relative;
  background: url('../../assets/img/diplome_abft.jpg') no-repeat;
  background-size: contain;
  font-family: 'Open Sans', sans-serif;

  &.backgroundDiplome {
    background: url('../../assets/img/diplome_abft.jpg') no-repeat;
    background-size: contain;
  }

  .block_left, .block_right {
    position: absolute;
    line-height: calc(80px * 0.3);
    text-align: left;
    font-family: 'Open Sans', sans-serif;
    width: 50%;

    input {
      width: 50%;
    }

    div:first-child {
      font-size: calc(50px * 0.35);

      span {
        font-weight: 500;
      }

    }

    div:last-child {
      font-size: calc(50px * 0.35);

      span {
        font-weight: bold;
      }

    }
  }

  .block_left {
    left: calc(250px * 0.3);
    top: calc(500px * 0.3);
  }

  .block_right {
    right: calc(250px * 0.3);
    top: calc(500px * 0.3);
    text-align: right;
  }


}

.previewContainer2 {
  width: 3508px;
  height: 2480px;
  border: 1px solid #000;
  position: relative;
  background: #FFF;
  background-size: contain;

  &.backgroundDiplome {
    background: url('../../assets/img/diplome_abft_hd.jpg') no-repeat;
  }

  .provisoire {
    color: #e3023e;
    text-transform: uppercase;
    font-family: 'Roboto', sans-serif;
    font-size: calc(200px);
    font-weight: bold;
    position: absolute;
    z-index: 99;
    transform: rotate(-90deg);
    top: calc(515px);
    left: calc(-400px);;
  }

  .provisoire_div {
    color: #e3023e;
    font-size: calc(48px);
    line-height: calc(48px);
    transform: rotate(-90deg);
    top: calc(600px);
    left: calc(-450px);;
    position: absolute;
  }

  .photo {
    position: absolute;
    right: 125px;
    top: 100px;
  }

  .caption {
    position: absolute;
    right: 95px;
    top: 660px;
    text-align: right;
    line-height: 100px;

    .captionContainer {
      position: relative;
      padding-right: 20px;
    }

    .hrVertical {
      position: absolute;
      right: 0px;
      top: 0px;
      height: 100%;
      width: 10px;

      &.backgroundDiplome {
        background-color: #0d76bd;
      }
    }

    .firstLine {
      font-family: 'Roboto', sans-serif;
      font-size: 120px;
      font-weight: bold;
    }

    .secondLine {
      font-family: 'Roboto', sans-serif;
      font-size: 120px;
      font-weight: bold;
    }


  }
}


</style>

<script type="text/babel">
import {mapGetters, mapActions} from 'vuex'
import cropUpload from '../Communs/ImgCropUpload'
import vSelect from "../Communs/vSelect";

var moment = require('moment')
var FileSaver = require('file-saver');
var $ = require('jquery');
var variables = require('../../assets/js/variables')
var _ = require('underscore')

require('../../../node_modules/bootstrap-datepicker/js/bootstrap-datepicker');
require('../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.fr');

export default {
  data() {
    return {
      inputActive: "",
      legend_block_left: "Période de formation",
      text_block_left: "28 novembre 2021",
      legend_block_right: "Date de remise",
      text_block_right: "28 novembre 2021",
      titre_obtenu: "Arbitre combat C",
      text_diplome: "Suite à la formation ABFT d’arbitrage combat qui a eu lieu en avril 2011,\n" +
        "Le responsable de la commission Arbitrage Combat  \n" +
        "[NAME_RESPONSABLE]\n" +
        "certifie par la présente que \n" +
        "[NAME]" +
        "a présenté et réussi la formation lui accordant le titre d’Arbitre Combat",
      photo_base64: null,
      loading: false,
      resize: false,
      redraw: "",
      show_upload_photo: false,
      generatingDiplome: false,
      ArrayMembersSearch: [],
      memberSelected: null,
      output: null,
      backgroundStyle: "diplome",
      printWithBackground: false,
      provisoire: false,
      date_fin_provisoire: null
    }
  },
  methods: {
    ...mapActions({
      majClubSelected: "majClubSelected",
    }),
    dataURItoBlob: function (dataURI) {
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      let byteString = atob(dataURI.split(',')[1]);

      // separate out the mime component
      let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      // write the bytes of the string to an ArrayBuffer
      let ab = new ArrayBuffer(byteString.length);

      // create a view into the buffer
      let ia = new Uint8Array(ab);

      // set the bytes of the buffer to the correct values
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      // write the ArrayBuffer to a blob, and you're done
      let blob = new Blob([ab], {type: mimeString});
      return blob;

    },
    async generateDiplome() {
      this.generatingDiplome = true
      const el = this.$refs.outputImg;
      // add option type to get the image version
      // if not provided the promise will return
      // the canvas.
      const options = {
        type: 'dataURL',
        // width: 1240,
        // height: 1748,
        // scale: 1
      }

      this.output = await this.$html2canvas(el, options).then((canvas) => {
        console.log(canvas);
        FileSaver.saveAs(this.dataURItoBlob(canvas), "DiplomeCoach" + _.random(0, 10000000) + ".png");
        // saveAs(canvas.toDataURL(), 'file-name.png');
      });
      this.generatingDiplome = false
    },
    clickOutside(event) {
      // console.log(event.className!="editable_input")
      if (event.className!="editable_input" || input == 'force_outside')
        this.inputActive = ""
    },
    SearchMembersResponse: function (search, loading) {
      if (search.length <= 2)
        return;
      let these = this;
      loading(true)
      this.$http.post(this.getRoute("memberSearch"), {q: search}, {
        before(request) {
          if (these.previousRequest)
            these.previousRequest.abort();
          these.previousRequest = request;
        }
      }).then(resp => {
        loading(false)
        let idsAlreadyExists = "";
        this.ArrayMembersSearch = resp.data;
        this.getCompetition.participations.forEach((item) => {
          this.ArrayMembersSearch = _.reject(this.ArrayMembersSearch, function (item2) {
            return item.membre.id == item2.id
          });
        })
        this.ArrayMembersSearch = _.where(this.ArrayMembersSearch, {licencie: true}).concat(_.where(this.ArrayMembersSearch, {licencie: false}))
      })
    },

    cropSuccess(imgDataUrl, field) {
      this.photo_base64 = imgDataUrl;
    },
    cropUploadSuccess(jsonData, field) {
    },
    cropUploadFail(status, field) {
    },
    titleCase(str) {
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return splitStr.join(' ');
    }

  },
  computed: {
    ...mapGetters({
      getClubSelected: 'getClubSelected',
      getRoute: 'getRoute'
    }),
    editor() {
    }
  },
  components: {
    'my-upload': cropUpload,
    vSelect,
  },
  watch: {

    memberSelected: function (value) {
      if (value && value != "") {
        this.memberSelected = null
      }
    }
  },
  mounted() {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/Outils/GenerationDiplome.vue